import { render, staticRenderFns } from "./detailCardToComFilm.vue?vue&type=template&id=6aaed580&scoped=true&"
import script from "./detailCardToComFilm.vue?vue&type=script&lang=js&"
export * from "./detailCardToComFilm.vue?vue&type=script&lang=js&"
import style0 from "./detailCardToComFilm.vue?vue&type=style&index=0&id=6aaed580&lang=scss&scoped=true&"
import style1 from "./detailCardToComFilm.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aaed580",
  null
  
)

export default component.exports